<script lang="ts">
    import { LL } from "../../../../i18n/i18n-svelte";
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import { ResizeMapFrontCommand } from "../../../Phaser/Game/MapEditor/Commands/Tilemap/ResizeMapFrontCommand";

    const gameScene = gameManager.getCurrentGameScene();
    const gameMapFrontWrapper = gameScene.getGameMapFrontWrapper();

    let width = $state(gameMapFrontWrapper.getMap().width ?? 0);
    let height = $state(gameMapFrontWrapper.getMap().height ?? 0);

    function applyResize() {
        const newWidth = Math.max(1, Math.floor(width));
        const newHeight = Math.max(1, Math.floor(height));
        const wamFile = gameScene.getGameMap().getWamFile();
        if (!wamFile) {
            return;
        }
        gameScene
            .getMapEditorModeManager()
            .executeCommand(new ResizeMapFrontCommand(wamFile, newWidth, newHeight, undefined, gameMapFrontWrapper))
            .catch((e) => console.error(e));
    }
</script>

<div class="flex flex-col gap-2">
    <h4 class="text-sm font-semibold">{$LL.mapEditor.tilemapEditor.resize()}</h4>
    <p class="text-xs text-white/70">{$LL.mapEditor.tilemapEditor.resizeWarning()}</p>
    <div class="flex items-center gap-2">
        <label class="text-xs flex items-center gap-1" for="tilemap-resize-width">
            {$LL.mapEditor.tilemapEditor.mapWidth()}
            <input
                id="tilemap-resize-width"
                type="number"
                min="1"
                class="w-16 px-1 py-0.5 rounded bg-white/10 text-sm"
                bind:value={width}
            />
        </label>
        <label class="text-xs flex items-center gap-1" for="tilemap-resize-height">
            {$LL.mapEditor.tilemapEditor.mapHeight()}
            <input
                id="tilemap-resize-height"
                type="number"
                min="1"
                class="w-16 px-1 py-0.5 rounded bg-white/10 text-sm"
                bind:value={height}
            />
        </label>
        <button type="button" class="px-2 py-1 text-xs rounded bg-secondary" onclick={applyResize}>
            {$LL.mapEditor.tilemapEditor.applyResize()}
        </button>
    </div>
</div>
